import gsap from "gsap";
import barba from '@barba/core';
import ScrollTrigger from "gsap/ScrollTrigger";

export default class{

	constructor(){
        gsap.registerPlugin(ScrollTrigger);
        this.addEvented = false
        barba.hooks.afterOnce((data) => {
            this.about()
        });
        barba.hooks.after((data) => {
            this.about()
        });
    }

    about(){
        const about = document.querySelector('#p-about');
        if (about) {
            ScrollTrigger.create({
                trigger: ".about-strength",
                start: 'top top',
                endTrigger: ".about-strength",
                end: 'bottom bottom',
                pin: ".about-strength__image",
                // pinSpacing: false,
                // markers: true
            });
            ScrollTrigger.refresh();
        }
    }
}